import React from 'react';
import useUser from '../store/selectors/useUser';
import useApiPost from '../api/useApiPost';
import useActiveBrand from '../store/selectors/useActiveBrand';
import useSelectedVideo from '../store/selectors/useSelectedVideo';
import useSelectedDetails from '../store/selectors/useSelectedDetails';
import useSelectedTemplateId from '../store/selectors/useSelectedTemplateId';
import useSelectedPrograms from '../store/selectors/useSelectedPrograms';
import useSelectedDocuments from '../store/selectors/useSelectedDocuments';
import useSelectedImages from '../store/selectors/useSelectedImages';

const buildFormData = ({ uId, bId, selectedVideo, templateId, selectedPrograms, selectedDocuments, selectedImages, type, details = undefined }) => {
  let formData = new FormData();
  formData.set('hID', 'getTemplatePreview');
  formData.set('uID', uId);
  formData.set('bID', bId);
  formData.set('vID', selectedVideo);
  formData.set('tID', templateId);
  formData.set('type', type);
  formData.set('programs', JSON.stringify(selectedPrograms));
  formData.set('files', JSON.stringify(selectedDocuments));
  formData.set('images', JSON.stringify(selectedImages));
  formData.set('includeSms', 'true');
  details && formData.set('details', JSON.stringify(details));
  return formData;
};

const mapResponseToData = response => response.data.result ?? '';

export default function useTemplatePreview() {
  const { id: uId } = useUser();
  const bId = useActiveBrand();
  const selectedVideo = useSelectedVideo();
  const { ...otherDetails } = useSelectedDetails();
  const templateId = useSelectedTemplateId();
  const { selectedPrograms } = useSelectedPrograms();
  const { selectedDocuments } = useSelectedDocuments();
  const { selectedImages } = useSelectedImages();

  const { data, handlePost, loading, error } = useApiPost({ mapResponseToData, defaultData: '' });
  const handleRefresh = React.useCallback(
    ({ includeDetails = false, onSuccess, onError }) => {
      handlePost({
        onSuccess,
        onError,
        data: buildFormData({ uId, bId, selectedVideo, templateId, selectedPrograms, selectedDocuments, selectedImages, details: includeDetails ? otherDetails : undefined, type: otherDetails?.type })
      });
    },
    // eslint-disable-next-line
    [uId, bId, selectedVideo, handlePost, templateId, selectedPrograms, selectedDocuments, selectedImages, JSON.stringify(otherDetails)]
  );

  return { templatePreview: data, getTemplatePreview: handleRefresh, loadingTemplatePreview: loading, error };
}
